import React from "react"
import { Timeline } from 'react-twitter-widgets'
import Helmet from 'react-helmet';

import Header from '../components/header.js'
import Navigation from '../components/navigation.js'
import Footer from '../components/footer.js'


export default ({ data }) => {
  const post = data.markdownRemark
  const slug = data.markdownRemark.fields.slug
  return (
<div>
  <Header metadata={data.site.siteMetadata} 
          hero={data.markdownRemark.frontmatter.hero} 
          heroPosition={data.markdownRemark.frontmatter.heroPosition}/>
  <Navigation slug={slug}/>
  <div className="container main-section">
    <Helmet>
      <title>Paul Kimbrel - {post.frontmatter.title}</title>
      <meta property="og:title" content={"Paul Kimbrel - "  + post.frontmatter.title} />
      <meta property="og:type" content="article" />
      <meta property="og:url" content={"https://www.paulkimbrel.com" + slug} />
      <meta property="og:description" content={post.excerpt} />
      <meta property="og:site_name" content="Paul Kimbrel - Internet hub for Paul Kimbrel, Web Developer and Systems Architect, Sound Engineer." />
      <meta property="article:published_time" content={post.frontmatter.date + "T00:0:00+00:00"} />
      <meta property="article:modified_time" content={post.frontmatter.date + "T00:0:00+00:00"} />
      <meta property="fb:admins" content="1014995487" />
      <meta property="fb:app_id" content="345839352494303" />
    </Helmet>
    <div className="row">
      <div className="col-sm-8 level-one">
        <article>
          <header>
            <h2 className="withDate">{post.frontmatter.title}</h2>
            <p><time dateTime={post.frontmatter.date}>{post.frontmatter.date}</time></p>
          </header>
          <div dangerouslySetInnerHTML={{ __html: post.html }} />
        </article>
      </div>
      <div className="col-sm-4 level-two">
        <Timeline dataSource={{sourceType: "profile", screenName: "pkimbrel"}}
                  options={{username:"reactjs",height: "500"}} />
      </div>
    </div>
  </div>
  <Footer />
</div>
  )
}

export const query = graphql`
  query BlogPostQuery($slug: String!) {
      site {
        siteMetadata {
          title,
          subtitle
        }
      }
      markdownRemark(fields: { slug: { eq: $slug } }) {
      html,
      excerpt,
      fields {
        slug
      },
      frontmatter {
        title,
        date(formatString: "DD MMMM, YYYY"),
        hero
        heroPosition
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/article.js